import { ExcelExporterService } from './../../excel-exporter.service';
import { UserSessionService } from './../../UserSession/user-session.service';
import { StringMapWithRename } from '@angular/compiler/src/compiler_facade_interface';
import { Component, Input, OnInit } from '@angular/core';
import { CustomReport, ReportsService } from './../../apiclient';
import * as moment from 'moment';
import { NbDialogRef, NbToastrService, NbDialogService } from '@nebular/theme';
import { ReportsInportConfirmationComponent } from './../reports-inport-confirmation/reports-inport-confirmation.component';

/**
 * Componente que rendeiza el importador de custom reports
 */
@Component({
  selector: 'ngx-custom-reports-importer',
  templateUrl: './custom-reports-importer.component.html',
  styleUrls: ['./custom-reports-importer.component.scss']
})
export class CustomReportsImporterComponent implements OnInit {


  @Input()
  reportType: string;

  @Input()
  tipoInformePlaceholder = "";

  tiposInforme = [];
  tipoInformeSeleccionado = null;
  literalTipoInforme = "";
  archivo: any;
  importError: any;
  loading = false;

  settings = {};  //Esther EV2022-02

  reportsToSave:any = {};

  constructor(private userSessionService: UserSessionService,private excelExporterService: ExcelExporterService,
    private reportsService: ReportsService, private dialogServiceRef: NbDialogRef<CustomReportsImporterComponent>,
    private toastService: NbToastrService,
    private dialogService: NbDialogService) { }

    /**
     * @ignore
     */
  ngOnInit(): void {
    this.settings = {
      text: "Tipo de reporte",
      selectAllText: 'Select All',
      unSelectAllText: 'UnSelect All',
      labelKey:"name",
      singleSelection: true,
      enableSearchFilter: true,
      searchPlaceholderText: 'Buscar',
    };  //Esther EV2022-02
    this.configurarFiltro();
  }


  /**
   * En función del tipo de reporte (Muestreo o Cuaderno) rellena el listado de tipos
   */
  configurarFiltro() {
    switch(this.reportType){

      case 'sampling':
          this.tipoInformePlaceholder = "Tipo de muestreo";
          this.literalTipoInforme = "Muestreos"
          this.userSessionService.getCachedSamplingList().subscribe((sampling) => {
            console.log(sampling);
            this.tiposInforme = sampling.map((muestreo) => {
              muestreo.name = muestreo.form_name;
              return muestreo;
            });

            console.log(this.tiposInforme)
          })
          break;
      case 'notebook':
            this.tipoInformePlaceholder = "Tipo de registro";
            this.literalTipoInforme = "Cuaderno de campo"
            this.userSessionService.getCachedNotebookList().subscribe((sampling) => {
              console.log(sampling);
              this.tiposInforme = sampling.map((muestreo) => {
                muestreo.name = muestreo.form_name;
                return muestreo;
              });
              console.log(this.tiposInforme)
            })
            break;

    }

    this.tiposInforme.sort((a,b)=>a.name.toLowerCase() < b.name.toLowerCase() ? -1 : 1);
  }

  /**
   * Genera la plantilla excel de importación
   */
  generarExcel(): void{
      this.excelExporterService.exportCustomForm(this.tipoInformeSeleccionado[0]);
  }

  /**
   * Importa el listado de reportes proporcioando en formato excel
   */
  async importarExcel() {
    this.loading = true
    this.importError = null
    try{
      this.reportsToSave = await this.excelExporterService.readCustomReport(this.archivo,this.tipoInformeSeleccionado[0])

      if(this.reportsToSave.notValid != undefined && this.reportsToSave.notValid != null && this.reportsToSave.notValid.length >0){
        //Hay que mostrar el modal de que hay errores
        this.dialogService.open(ReportsInportConfirmationComponent,{context:{reportsToSave:this.reportsToSave,formId:this.tipoInformeSeleccionado[0].id,importerDialogRef:this.dialogServiceRef}})
      }else if (this.reportsToSave.valid != undefined && this.reportsToSave.valid != null && this.reportsToSave.valid.length == 0){
        this.toastService.danger('El archivo excel no contiene datos','Importación de reportes')

      }else{
        this.confirmImportarExcel();
      }


    }catch(e){
      if(e == 'outdatedTemplate'){
        this.toastService.danger('La plantilla excel utilizada no corresponde a la versión actual del Formulario Personalizado','Importación de reportes')
      }else{
        this.importError =JSON.parse(e.message);
      }

    }finally{
      this.loading = false
    }

  }


  confirmImportarExcel(){
    this.loading = true
    let customReports : CustomReport[] = []
    var ms = 0;
    this.reportsToSave.valid.forEach(i => {
      customReports.push({form:''+this.tipoInformeSeleccionado[0].id,formData:i,timestamp: moment().add(ms,'ms').toDate()})
      ms+=1;
    })

      this.reportsService.customreport(customReports,this.userSessionService.accessToken).subscribe(r => {
        console.log(r)
        this.dialogServiceRef.close()
        this.toastService.success('Los reportes se han subido correctamente','Importación de reportes')
        this.loading = false
      },error => {
        this.dialogServiceRef.close()

      })

  }

  /**
   * @ignore
   * @param archivos
   */
  actualizarArchivo(archivos: FileList){

    console.log(archivos);
    this.archivo = archivos.item(0)



  }
}
